import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { AgentPresenceProps } from '../src/AgentPresence/AgentPresence.tsx';

export const AgentPresenceLoader: LoadableType<AgentPresenceProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentPresence" */ '../src/AgentPresence/AgentPresence.tsx'
			)
		).AgentPresence,
});
